import React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import Divider from '@mui/material/Divider';
export default function MobileNavigation(props) {
    const { navigation, mobileOpen, navigationLinks, setMobileOpen, } = props;
    const [navMobileOpen, setNavMbileOpen] = React.useState(mobileOpen);
    React.useEffect(() => {
        setNavMbileOpen(mobileOpen);
    }, [mobileOpen]);
    function handleNavItemClick(item) {
        window.location.href = item.url;
        setNavMbileOpen(false);
        setMobileOpen(false);
        document.body.style.overflow = 'auto';
    }
    function onNavLinkClick(link) {
        window.location.href = link;
        setNavMbileOpen(false);
        setMobileOpen(false);
        document.body.style.overflow = 'auto';
    }
    const listItemSX = {
        py: 1.5,
        px: 3.5,
        justifyContent: 'space-between',
    };
    const primaryTypographySX = {
        color: 'primary.light',
        fontSize: 14,
        fontWeight: 400,
        lineHeight: 1.28,
        letterSpacing: '0.06em',
        WebkitUserSelect: 'none',
        MozUserSelect: 'none',
        msUserSelect: 'none',
        userSelect: 'none',
    };
    return (React.createElement(Collapse, { in: navMobileOpen, timeout: 100, unmountOnExit: true, sx: {
            bgcolor: 'background.paper',
            position: 'fixed',
            width: '100%',
            zIndex: 1000,
            overflowY: 'scroll',
            maxHeight: '85%',
            mt: -0.125,
        } },
        React.createElement(List, { component: "nav", disablePadding: true }, navigation === null || navigation === void 0 ? void 0 : navigation.map((item) => (React.createElement(React.Fragment, { key: item.key },
            React.createElement(Divider, { sx: { width: '100%', borderColor: 'secondary.dark' } }),
            React.createElement(ListItem, { disableGutters: true, sx: listItemSX, component: item.link !== '' ? 'a' : null, href: item.link },
                React.createElement(ListItemText, { primary: item.title, onClick: () => handleNavItemClick(item), slotProps: {
                        primary: {
                            noWrap: true,
                            sx: { ...primaryTypographySX, textTransform: 'uppercase' },
                        },
                    } })))))),
        React.createElement(Collapse, { in: mobileOpen, timeout: 100, unmountOnExit: true, sx: { bgcolor: 'background.paper' } },
            React.createElement(List, { component: "nav", disablePadding: true }, navigationLinks.map((navItem) => (React.createElement(ListItem, { disableGutters: true, sx: listItemSX, key: navItem.link, onClick: () => onNavLinkClick(navItem.link), component: "a", href: navItem.link },
                React.createElement(ListItemText, { primary: navItem.text, slotProps: {
                        primary: {
                            noWrap: true,
                            sx: { ...primaryTypographySX, fontWeight: 'bold' },
                        },
                    } }))))))));
}
